import { Debouncer } from "./debouncer";

const debouncer = new Debouncer();
export const fetchData = async (url, { method, ...options }, raw = false) => {
  const data = await fetch(url, { method, ...options });

  return raw ? data : await data.json();
};
